<app-card-medium title="{{ 'New User' | translate }}">
  <div class="content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div style="overflow: scroll; margin-bottom: 0.5em">
        <div class="form-group">
          <!-- <label for="exampleInputEmail1">Full name</label> -->
          <input
            formControlName="fullname"
            type="text"
            class="form-control"
            placeholder="{{ 'Fullname' | translate }}"
            [ngClass]="{
              'is-invalid': submitted && form.controls.fullname.errors
            }"
          />
          <div
            *ngIf="submitted && form.controls.fullname.errors"
            class="invalid-feedback"
          >
            <small *ngIf="form.controls.fullname.errors.required">{{
              "Name is required" | translate
            }}</small>
          </div>
          <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
        </div>
        <div class="form-group">
          <input
            formControlName="username"
            type="text"
            class="form-control"
            [ngClass]="{
              'is-invalid': submitted && form.controls.username.errors
            }"
            placeholder="{{ 'Username' | translate }}"
            autocomplete="off"
          />
          <div
            *ngIf="submitted && form.controls.username.errors"
            class="invalid-feedback"
          >
            <small *ngIf="form.controls.username.errors.required">{{
              "Username is required" | translate
            }}</small>
          </div>
        </div>
        <div class="form-group">
          <select
            formControlName="role"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && form.controls.role.errors }"
          >
            <option value="" disabled selected>
              {{ "Select role" | translate }}
            </option>
            <option *ngFor="let role of roles; trackById" value="{{ role }}">
              {{ role === "SuperAdmin" ? "Maintainer" : (role | translate) }}
            </option>
          </select>
          <div
            *ngIf="submitted && form.controls.role.errors"
            class="invalid-feedback"
          >
            <small *ngIf="form.controls.role.errors.required">{{
              "Role is required" | translate
            }}</small>
          </div>
        </div>
        <div class="form-group" *ngIf="isSuperAdmin">
          <select
            formControlName="organisation"
            class="form-control"
            [ngClass]="{
              'is-invalid': submitted && form.controls.organisation.errors
            }"
          >
            <option value="" disabled selected>
              {{ "Select Organisation" | translate }}
            </option>
            <option
              *ngFor="let organisation of organisations; trackById"
              value="{{ organisation.id }}"
            >
              {{ organisation.name }}
            </option>
          </select>
          <div
            *ngIf="submitted && form.controls.organisation.errors"
            class="invalid-feedback"
          >
            <small *ngIf="form.controls.organisation.errors.required">{{
              "Organisation is required" | translate
            }}</small>
          </div>
        </div>
        <div class="form-group">
          <input
            formControlName="email"
            type="text"
            class="form-control"
            placeholder="{{ 'Email Address' | translate }}"
            [ngClass]="{
              'is-invalid': submitted && form.controls.email.errors
            }"
          />
          <div
            *ngIf="submitted && form.controls.email.errors"
            class="invalid-feedback"
          >
            <small *ngIf="form.controls.email.errors.required">{{
              "Email is required" | translate
            }}</small>
          </div>
        </div>
        <div class="form-group">
          <input
            formControlName="contact_detail"
            type="text"
            class="form-control"
            placeholder="{{ 'Contact Details' | translate }}"
          />
        </div>
        <div class="form-group">
          <input
            formControlName="job_title"
            type="text"
            class="form-control"
            placeholder="{{ 'Job Title' | translate }}"
          />
        </div>
        <div class="form-group">
          <textarea
            formControlName="office_address"
            class="form-control"
            placeholder="{{ 'Office Address' | translate }}"
          ></textarea>
        </div>
        <div class="form-group">
          <input
            formControlName="facilityCodeAccessLogin"
            type="text"
            class="form-control"
            placeholder="{{ 'Facilities Code Access Login' | translate }}"
          />
        </div>
        <div>
          <p>{{ "Groups" | translate }}</p>
          <div style="display: flex; justify-content: center">
            <div
              style="
                display: flex;
                width: 250px;
                justify-content: space-between;
              "
            >
              <app-toggle-switch
                [selected]="selectAllGroups"
                [forOthers]="true"
                (change)="onChangeAllGroup()"
              >
              </app-toggle-switch>
              <p>{{ "All" | translate }}</p>
            </div>
          </div>
          <div *ngFor="let group of groups; let i = index; trackById">
            <div style="display: flex; justify-content: center">
              <div
                style="
                  display: flex;
                  width: 250px;
                  justify-content: space-between;
                "
              >
                <app-toggle-switch
                  [selected]="group.member"
                  [forOthers]="true"
                  (change)="onChangeGroup(i)"
                ></app-toggle-switch>
                <p>{{ group.name | translate }}</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p>{{ "Locations" | translate }}</p>
          <div style="display: flex; justify-content: center">
            <div
              style="
                display: flex;
                width: 250px;
                justify-content: space-between;
              "
            >
              <app-toggle-switch
                [selected]="selectAllLocations"
                [forOthers]="true"
                (change)="onChangeAllLocations()"
              >
              </app-toggle-switch>
              <p>{{ "All" | translate }}</p>
            </div>
          </div>
          <div *ngFor="let location of locations; let i = index; trackById">
            <div *ngIf="!location.parent">
              <div style="display: flex; justify-content: center">
                <div
                  style="
                    display: flex;
                    width: 250px;
                    justify-content: space-between;
                  "
                >
                  <app-toggle-switch
                    [selected]="location.member"
                    [forOthers]="true"
                    (change)="onChangeLocation(i)"
                  ></app-toggle-switch>
                  <p>{{ location.name | translate }}</p>
                </div>
              </div>
            </div>
            <div *ngIf="location.parent">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  padding-left: 2em;
                "
              >
                <div
                  style="
                    display: flex;
                    width: 250px;
                    justify-content: space-between;
                  "
                >
                  <app-toggle-switch
                    [selected]="location.member"
                    [forOthers]="true"
                    (change)="onChangeLocation(i)"
                  ></app-toggle-switch>
                  <p>{{ location.name | translate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-buttons">
        <button
          type="button"
          class="btn btn-sm btn-secondary"
          routerLink="/users"
        >
          {{ "Discard" | translate }}
        </button>
        <button type="submit" class="btn btn-sm btn-primary">
          {{ "Save" | translate }}
        </button>
      </div>
    </form>
  </div>
</app-card-medium>
